import { render } from "./DrugTestMetricReport.vue?vue&type=template&id=408a8a31&ts=true"
import script from "./DrugTestMetricReport.vue?vue&type=script&lang=ts"
export * from "./DrugTestMetricReport.vue?vue&type=script&lang=ts"

import "./DrugTestMetricReport.vue?vue&type=style&index=0&id=408a8a31&lang=css"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__